var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
import { __decorate, __metadata } from "tslib";
// Types
import * as angular from 'angular';
import { ITimeoutService, translate } from 'angular';
import { immutableSplice } from 'data/array';
// Core
import { Component } from 'decorators';
import { ActionType } from 'modules/application/detail/portal-submodule-builder/templates/builder/models/Action';
import { Input } from 'modules/application/detail/portal-submodule-builder/templates/builder/models/Input';
import { SendMessageFromHttpActionSettings } from 'modules/application/detail/portal-submodule-builder/templates/builder/models/SendMessageFromHttpActionSettings';
import { SendRawMessageActionSettings } from 'modules/application/detail/portal-submodule-builder/templates/builder/models/SendRawMessageActionSettings';
import { ActionViewModel } from 'modules/application/detail/portal-submodule-builder/templates/builder/models/viewModels/ActionViewModel';
import { CardContent, } from 'modules/application/detail/portal-submodule-builder/templates/builder/models/viewModels/CardContent';
import { ContentActionViewModel } from 'modules/application/detail/portal-submodule-builder/templates/builder/models/viewModels/ContentActionViewModel';
import { InputViewModel } from 'modules/application/detail/portal-submodule-builder/templates/builder/models/viewModels/InputViewModel';
import { OutputViewModel } from 'modules/application/detail/portal-submodule-builder/templates/builder/models/viewModels/OutputViewModel';
import { BuilderStore } from '../../../../store/BuilderStore';
// Services
import { BuilderContentService } from 'modules/application/detail/portal-submodule-builder/templates/builder/services/BuilderContentService';
// Constants
import { DESK_ID_PREFIX, DESK_REDIRECT_OUT_OF_ATTENDANCE_TIME_MIN_STATE_VERSION, STATE_ID_END, STATE_ID_FALLBACK, STATE_ID_ONBOARDING, SUBFLOW_ID_PREFIX, BuilderStateService } from 'modules/application/detail/portal-submodule-builder/templates/builder/services/BuilderStateService';
import { BuilderContentType } from 'modules/application/detail/portal-submodule-builder/templates/builder/tabs/content/BuilderContentType';
import { Add, AddWithChatState, AddWithChatStateUserInput, } from 'modules/application/detail/portal-submodule-builder/templates/builder/tabs/content/components/addContent/addContent.dispatcher';
import { ContentUpdateAndSave, } from 'modules/application/detail/portal-submodule-builder/templates/builder/tabs/content/components/contents/contents.dispatcher';
// Controllers
import { HttpContentController } from 'modules/application/detail/portal-submodule-builder/templates/builder/tabs/content/HttpContentController';
import { InputController } from 'modules/application/detail/portal-submodule-builder/templates/builder/tabs/content/InputController';
import { MetadataController } from 'modules/application/detail/portal-submodule-builder/templates/builder/tabs/content/metadata/MetadataController';
import { RawContentController } from 'modules/application/detail/portal-submodule-builder/templates/builder/tabs/content/RawContentController';
import { UndoRedoService } from 'modules/application/misc/UndoRedoService';
import { SidebarContentService } from 'modules/shared/SidebarContentService';
import { v4 as uuid } from 'uuid';
import { BuilderFeatures } from '../../../../BuilderFeatures';
import { CardContentIAction } from '../../../../historyActions';
import { BuilderSegmentService } from '../../../../services/BuilderSegmentService';
import { BuilderTabsService } from '../../../../services/BuilderTabsService';
import { ActionContentService } from '../../../../services/ActionContentService';
import HttpContentView from '../../HttpContentView.html';
import InputView from '../../InputView.html';
import MetadataView from '../../metadata/MetadataView.html';
import RawContentView from '../../RawContentView.html';
import { SurveyContentController } from '../../survey/SurveyContentController';
import SurveyContentView from '../../survey/SurveyContentView.html';
// Views
import template from './ContentsView.html';
import './ContentsView.scss';
import { SmartSalesConstants } from '../../../../smartSales/SmartSalesConstants';
const builderStore = BuilderStore.getInstance();
export const validateContentTab = state => {
    const contentActionsTabElement = document.getElementById('content-tab-0');
    if (state.$invalidContentActions) {
        contentActionsTabElement?.classList.add('invalid-background');
    }
    else {
        contentActionsTabElement?.classList.remove('invalid-background');
    }
};
var ValueSource;
(function (ValueSource) {
    ValueSource["Intent"] = "intent";
    ValueSource["Entity"] = "entity";
    ValueSource["ContentAssistant"] = "content assistant";
})(ValueSource || (ValueSource = {}));
const loadingTimeout = 300; // This value in ms doesn't impact user experience
let ContentsComponent = class ContentsComponent {
    static $inject = ['BuilderContentService', 'BuilderTabsService', 'SidebarContentService', 'BuilderSegmentService', '$document', '$timeout', '$translate', 'ModalService', 'UndoRedoService', '$scope', 'BuilderStateService', 'ActionContentService'];
    constructor(BuilderContentService, BuilderTabsService, SidebarContentService, BuilderSegmentService, $document, $timeout, $translate, ModalService, UndoRedoService, $scope, BuilderStateService, ActionContentService) {
        'ngInject';
        this.BuilderContentService = BuilderContentService;
        this.BuilderTabsService = BuilderTabsService;
        this.SidebarContentService = SidebarContentService;
        this.BuilderSegmentService = BuilderSegmentService;
        this.$document = $document;
        this.$timeout = $timeout;
        this.$translate = $translate;
        this.ModalService = ModalService;
        this.UndoRedoService = UndoRedoService;
        this.$scope = $scope;
        this.BuilderStateService = BuilderStateService;
        this.ActionContentService = ActionContentService;
        this.hasInput = false;
        this.showCounter = false;
        this.isLoading = true;
    }
    async $onInit() {
        // Bind the content listeners
        this.bindAllCardListeners();
        await this.checkFeatures();
        // Allow digest to load vue card components width calculation preventing overflow issues
        this.$timeout(() => {
            this.isLoading = false;
        }, loadingTimeout);
        this.isDeskState = this.state.id.startsWith(DESK_ID_PREFIX);
        this.isSubflowState = this.state.id.startsWith(SUBFLOW_ID_PREFIX);
        this.isOnboardingState = this.state.id === STATE_ID_ONBOARDING;
        this.isFallbackState = this.state.id === STATE_ID_FALLBACK;
        this.isEndState = this.state.id === STATE_ID_END;
        this.hasOnlyUserInput = (this.state.id === STATE_ID_ONBOARDING && this.application.isSubflow);
        this.showCounter = this.shouldShowContentCounter();
        this.errorMessage = await this.$translate('builder-tabs-content.InputIsEmpty');
        this.isSmartSalesState = this.state.id.startsWith(SmartSalesConstants.STATE_ID_PREFIX);
        this.checkContentLength();
        this.isDeskStateOutdated = this.checkOutdatedDeskVersion();
        this.ngSortableOptions = {
            animation: 0,
            scroll: true,
            handle: '.anchor',
            onSort: (e) => {
                const cardContentIAction = new CardContentIAction({
                    data: {
                        state: {
                            id: angular.copy(this.state.id),
                            $title: angular.copy(this.state.$title),
                        },
                        content: this.state.$contentActions[e?.oldIndex],
                        outputConditionsBefore: this.state.$conditionOutputs,
                    },
                    execute: async () => {
                        this.swapContentsPosition(e?.oldIndex, e?.newIndex);
                        await this.onUpdateAndSave();
                    },
                    undo: async (data) => {
                        this.swapContentsPosition(e?.newIndex, e?.oldIndex);
                        await this.onUpdateAndSave();
                    },
                });
                if (this.isBuilderUndoRedoContentEnabled) {
                    this.UndoRedoService.add(cardContentIAction);
                }
                this.trackAndSaveOutputSort();
            },
        };
        this.addContentEnabled =
            this.state.id != STATE_ID_ONBOARDING &&
                this.state.id != STATE_ID_FALLBACK &&
                this.state.id != STATE_ID_END &&
                !this.isDeskState &&
                !this.isSmartSalesState;
        this.$scope.$watch('$ctrl.state.$contentActions', () => {
            this.hasInput = this.state.$contentActions.some(ca => ca?.input?.bypass === false);
        });
        setTimeout(() => validateContentTab(this.state));
    }
    getBaseUrl() {
        return this.application.isSubflow ? `../../../${this.application.callerApplication.shortName}` : '../..';
    }
    async trackClickUrlContentDocumentation(property) {
        this.trackClickUrlContent(property);
    }
    async checkFeatures() {
        this.isBuilderUndoRedoContentEnabled = await BuilderFeatures.builderUndoRedoContentEnabled();
        this.displayUpgradeDeskVersion = await BuilderFeatures.displayUpgradeDeskVersion();
        this.isBuilderAddOutputConditionsOnContentChange = await BuilderFeatures.builderAddOutputConditionsOnContentChange();
        this.isDeskStateUpgradeToVersion3 = this.displayUpgradeDeskVersion && this.BuilderStateService.deskStateVersion >= DESK_REDIRECT_OUT_OF_ATTENDANCE_TIME_MIN_STATE_VERSION;
    }
    shouldShowContentCounter() {
        return this.state.id !== STATE_ID_ONBOARDING
            && this.state.id !== STATE_ID_FALLBACK
            && this.state.id !== STATE_ID_END
            && !this.isDeskState
            && !this.isSmartSalesState;
    }
    checkOutdatedDeskVersion() {
        return this.displayUpgradeDeskVersion
            && (this.state.id?.startsWith(DESK_ID_PREFIX)
                && (this.BuilderStateService.deskStateVersion > parseFloat(this.state.deskStateVersion) || !this.state.deskStateVersion));
    }
    checkContentLength() {
        const counter = this.state.$contentActions.filter((c) => !c.input &&
            (c.action &&
                c.action.settings.type !==
                    'application/vnd.lime.chatstate+json')).length;
        this.disableAddContent = {
            counter,
            addDisabled: counter > 24,
        };
    }
    swapContentsPosition(firstContentIndex, secondContentIndex) {
        const firstContent = this.state.$contentActions[firstContentIndex];
        const secondContent = this.state.$contentActions[secondContentIndex];
        this.state.$contentActions[firstContentIndex] = secondContent;
        this.state.$contentActions[secondContentIndex] = firstContent;
    }
    canAddMiddleContent(content) {
        const shouldBypass = (c) => c.input && c.input.bypass;
        return (this.state.id !== STATE_ID_ONBOARDING
            && ((this.addContentEnabled && !content.input)
                || (this.addContentEnabled && !shouldBypass(content))));
    }
    /**
     * Dispatch content action
     * @param $action
     */
    $dispatch($action) {
        if (this.onAction) {
            this.onAction({ $action });
        }
        else {
            throw new Error('onAction is not implemented');
        }
    }
    bindAllCardListeners() {
        this.state.$contentActions.forEach(async (a) => {
            let $cardContent;
            if (a.action && a.action.$cardContent) {
                $cardContent = a.action.$cardContent;
            }
            else if (a.input && a.input.$cardContent) {
                $cardContent = a.input.$cardContent;
                if ($cardContent.document.content == undefined ||
                    $cardContent.document.content == '') {
                    $cardContent.document.content = await this.$translate('builder-tabs-content.media.userInput');
                }
            }
            if ($cardContent) {
                await this.bindCardListeners($cardContent, a.input !== undefined);
            }
        });
    }
    async bindCardListeners(cardContent, isInput = false) {
        cardContent['on-save'] = (document) => this.onActionSave(document);
        cardContent['on-deleted'] = (document) => {
            if (isInput) {
                this.removeUserInput();
            }
            else {
                this.onActionDeleted(document);
                this.checkContentLength();
            }
        };
        cardContent['on-metadata-edit'] = (document) => this.onActionMetadataEdit(document);
    }
    updateCurrentStateContentAction({ cardContent, cardDocument, cardActionIndex }) {
        this.state.$contentActions[cardActionIndex] = cardContent;
        if (this.state.$contentActions[cardActionIndex].action?.$cardContent) {
            this.state.$contentActions[cardActionIndex].action.$cardContent.document = {
                ...cardDocument,
                ...cardContent.action.settings,
            };
        }
    }
    async onActionSave(document, actionIndex = undefined) {
        if (actionIndex === undefined) {
            actionIndex = this.state.$contentActions.findIndex((a) => a.action && a.action.$cardContent && a.action.$cardContent.document.id == document.id);
        }
        const contentAction = this.state.$contentActions[actionIndex];
        let allOutputConditions = this.state.$conditionOutputs;
        if (this.isBuilderAddOutputConditionsOnContentChange) {
            allOutputConditions = this.ActionContentService.getAllOutputConditions(contentAction, this.state.$conditionOutputs)
                || this.state.$conditionOutputs;
        }
        const cardContentIAction = new CardContentIAction({
            data: {
                state: {
                    id: this.state.id,
                    $title: this.state.$title,
                },
                content: angular.copy(contentAction),
                outputConditionsBefore: this.state.$conditionOutputs,
            },
            execute: async () => {
                this.updateCurrentStateContentAction({
                    cardContent: contentAction,
                    cardDocument: this.state.$contentActions[actionIndex].action?.$cardContent?.document,
                    cardActionIndex: actionIndex,
                });
                this.state.$conditionOutputs = allOutputConditions;
                builderStore.setState({
                    ...this.state,
                });
                await this.onUpdateAndSave();
            },
            undo: async (data) => {
                this.updateCurrentStateContentAction({
                    cardContent: data.content,
                    cardDocument: this.state.$contentActions[actionIndex].action?.$cardContent?.document,
                    cardActionIndex: actionIndex,
                });
                this.state.$conditionOutputs = data.outputConditionsBefore;
                builderStore.setState({
                    ...this.state,
                });
                await this.onUpdateAndSave();
            },
        });
        if (contentAction && (contentAction.action.type == ActionType.SendMessage ||
            contentAction.action.type == ActionType.SendMessageFromHttp ||
            contentAction.action.type == ActionType.SendRawMessage ||
            contentAction.action.type == ActionType.SurveyType)) {
            this.state.$contentActions[actionIndex].action.settings = {
                ...document,
                metadata: document.metadata || contentAction.action.settings.metadata || {},
            };
            this.injectMessageMetadata(contentAction.action);
        }
        if (this.isBuilderUndoRedoContentEnabled) {
            this.UndoRedoService.add(cardContentIAction);
        }
        const contentText = contentAction?.action?.settings?.content;
        if (contentText && !contentText.text && !contentText.interval) {
            if (String(contentText).match(/\{\{input.intent.(\w+)\}\}/g)) {
                this.trackBuilderBlockAiActivated(ValueSource.Intent);
            }
            if (String(contentText).match(/\{\{input.entity.(\w+)\}\}/g)) {
                this.trackBuilderBlockAiActivated(ValueSource.Entity);
            }
            if (String(contentText).match(/\{\{input.contentAssistant.(\w+)\}\}/g)) {
                this.trackBuilderBlockAiActivated(ValueSource.ContentAssistant);
            }
        }
        if (contentAction.action) {
            this.trackBlockContentChanged(contentAction.action.type);
        }
        if (this.isBuilderAddOutputConditionsOnContentChange) {
            this.state.$conditionOutputs = allOutputConditions;
            builderStore.setState({
                ...this.state,
            });
        }
        this.updateInputSuggestions();
        await this.onUpdateAndSave();
        if (this.state?.$contentActions[actionIndex]?.action?.settings?.content?.scope != 'immediate') {
            this.checkLimitMenu(actionIndex);
        }
        else {
            this.checkLimitQuikReply(actionIndex);
        }
    }
    async onActionDeleted(document) {
        const index = this.state.$contentActions.findIndex((a) => a.action &&
            a.action.$cardContent &&
            a.action.$cardContent.document &&
            a.action.$cardContent.document.id == document.id);
        if (index >= 0) {
            await this.deleteContentAction(index);
        }
        else {
            /**
             * This assignment dispatch $contentActions proxy,
             * so we don't need to create another action here
             * */
            this.state.$contentActions = this.state.$contentActions.map((a) => {
                if (a.input &&
                    a.input.$cardContent.document.id == document.id) {
                    a.input = this.createDefaultInputViewModel();
                    this.trackBlockContentWaitInputDisabled();
                }
                return a;
            });
            await this.onUpdateAndSave();
        }
        this.updateInputSuggestions();
    }
    async onActionMetadataEdit(document) {
        const contentAction = this.state.$contentActions.find((a) => a.action && a.action?.$cardContent?.document?.id == document?.id);
        return this.openSidebarDetail(MetadataController, MetadataView, {
            action: contentAction.action,
            application: this.application,
            $translate: this.$translate,
            $onStateChanged: async (action) => {
                this.onUpdateAndSave();
            },
            ModalService: this.ModalService,
            state: this.state,
        });
    }
    createDefaultInputViewModel(textContent, inputState) {
        let inputStateObj;
        const content = textContent ||
            this.$translate.instant('builder-tabs-content.media.userInput');
        if (inputState) {
            inputStateObj = inputState;
        }
        else {
            inputStateObj = new Input();
            inputStateObj.bypass = true;
        }
        const cardContent = CardContent.create({
            id: uuid(),
            type: 'text/plain',
            content,
        }, 'right', false);
        this.bindCardListeners(cardContent, true);
        return new InputViewModel({
            ...inputStateObj,
            $cardContent: cardContent,
        });
    }
    injectMessageMetadata(action) {
        if (!action.settings) {
            return;
        }
        const contentJson = JSON.stringify(action.settings.content);
        const addMessageMetadataKey = (message, metadataKey, metadataValue) => {
            if (!message.metadata) {
                message.metadata = {};
            }
            message.metadata[metadataKey] = metadataValue;
        };
        const removeMessageMetadataKey = (message, metadataKey) => {
            if (message.metadata) {
                delete message.metadata[metadataKey];
            }
        };
        // Inject the replace metadata if there's any server variable (${variable}) in the content
        const messageReplaceVariablesMetadataKey = '#message.replaceVariables';
        if (contentJson?.match(/(\${[a-zA-Z0-9\.]+\})/)) {
            addMessageMetadataKey(action.settings, messageReplaceVariablesMetadataKey, 'true');
        }
        else {
            removeMessageMetadataKey(action.settings, messageReplaceVariablesMetadataKey);
        }
        // Inject the spin metadata if there's any pipe in the content
        const messageSpinTextMetadataKey = '#message.spinText';
        if (contentJson?.indexOf('|') >= 0) {
            addMessageMetadataKey(action.settings, messageSpinTextMetadataKey, 'true');
        }
        else {
            removeMessageMetadataKey(action.settings, messageSpinTextMetadataKey);
        }
    }
    onUpdateAndSave() {
        const action = new ContentUpdateAndSave();
        this.$dispatch(action);
        validateContentTab(this.state);
    }
    /**
     * Delegate actions according with type
     * @param $action
     */
    onContentAction(action) {
        switch (action.constructor) {
            case AddWithChatState:
                this.addContentWithChatState(action);
                break;
            case AddWithChatStateUserInput:
                this.addContentWithChatStateUserInput(action);
                break;
            case Add:
                this.addContent(action);
                break;
            default:
                throw new Error('Unrecognized action dispatcher type');
        }
        this.checkContentLength();
    }
    addContentWithChatStateUserInput({ type, index, }) {
        this.addContent({ type: BuilderContentType.UserInput, index });
        this.addContentWithChatState({ type, index });
    }
    addContentWithChatState({ type, index, }) {
        const listLength = this.state.$contentActions.length;
        let cardPosition;
        // If user input is the last card contend, every cardContent will be inserted before it.
        // If method receives an index, the card content will be inserted on index specified.
        if (this.state.$contentActions[listLength - 1].input &&
            listLength > 0 &&
            index == undefined) {
            cardPosition = listLength - 1;
        }
        else {
            if (index == undefined) {
                index = listLength;
            }
            cardPosition = index;
        }
        this.addContent({ type, index: cardPosition, save: false });
        this.addContent({
            type: BuilderContentType.ChatState,
            index: cardPosition,
        });
        this.updateInputSuggestions();
    }
    addBuiltContentInPosition({ content, index }) {
        this.state.$contentActions = immutableSplice(this.state.$contentActions, index, 0, content);
    }
    addContent({ type, index = this.state.$contentActions.length, save = true, }) {
        if (type == BuilderContentType.UserInput) {
            const input = this.state.$contentActions.find(a => a.input);
            // Remove the existing action and add it again
            this.state.$contentActions = this.state.$contentActions.filter((a) => a.input == undefined).concat([{
                    ...input,
                    input: {
                        ...input.input,
                        bypass: false,
                    },
                }]);
            this.trackBlockContentWaitInputEnabled();
        }
        else {
            // In case of a content action, check if is a http/raw conent (SendMessageFromHttp/SendRawMessage) or just a static conent (SendMessage).
            let contentActionViewModel;
            switch (type) {
                case BuilderContentType.HttpContent:
                    contentActionViewModel = new ContentActionViewModel({
                        action: new ActionViewModel({
                            type: ActionType.SendMessageFromHttp,
                            settings: new SendMessageFromHttpActionSettings(),
                            $typeOfContent: type,
                        }),
                    });
                    this.trackBlockContentAdded(type);
                    break;
                case BuilderContentType.RawContent:
                    contentActionViewModel = new ContentActionViewModel({
                        action: new ActionViewModel({
                            type: ActionType.SendRawMessage,
                            settings: new SendRawMessageActionSettings(),
                            $typeOfContent: type,
                        }),
                    });
                    this.trackBlockContentAdded(type);
                    break;
                default:
                    const contentTemplate = this.BuilderContentService.getContentTemplate(type);
                    contentActionViewModel = new ContentActionViewModel({
                        action: new ActionViewModel({
                            type: ActionType.SendMessage,
                            settings: angular.copy(contentTemplate),
                            $cardContent: this.createCardContent(contentTemplate),
                            $typeOfContent: type,
                        }),
                    });
                    this.trackBlockContentAdded(type);
                    break;
            }
            this.addBuiltContentInPosition({
                content: contentActionViewModel,
                index,
            });
            // Open the sidebar in case of http/raw contents.
            switch (type) {
                case BuilderContentType.HttpContent:
                    this.openHttpContentSidebarDetail(contentActionViewModel, index + 1);
                    break;
                case BuilderContentType.RawContent:
                    this.openRawContentSidebarDetail(contentActionViewModel, index + 1);
                    break;
                case BuilderContentType.Select:
                case BuilderContentType.SelectImmediate:
                    if (this.isBuilderAddOutputConditionsOnContentChange) {
                        this.state.$conditionOutputs = this.createOutputConditions(this.state.$conditionOutputs, contentActionViewModel);
                    }
                    break;
            }
        }
        if (save) {
            this.onUpdateAndSave();
        }
    }
    async removeUserInput() {
        const defaultValidation = undefined; // Default input validation should be undefined in the first time
        this.state.$contentActions = this.state.$contentActions.map((a) => {
            if (a.input) {
                this.cleanInput(a.input);
                return {
                    ...a,
                    input: {
                        ...a.input,
                        bypass: true,
                        validation: defaultValidation,
                    },
                };
            }
            return a;
        });
        this.onUpdateAndSave();
        this.trackBlockContentWaitInputDisabled();
    }
    cleanInput(input) {
        input.$cardContent.document.content = this.$translate.instant('modules.docs.userInput');
        delete input.variable;
        delete input.expiration;
    }
    /**
     * Update the suggestions values for the user input in the output conditions.
     */
    updateInputSuggestions() {
        let inputSuggestions = [];
        this.state.$contentActions.forEach((c) => {
            if (c.action &&
                c.action.type == ActionType.SendMessage &&
                c.action.settings) {
                const message = c.action.settings;
                // Menu and quick replies
                if (message.type == 'application/vnd.lime.select+json' &&
                    message.content &&
                    message.content.options) {
                    message.content.options.forEach((option) => {
                        let value;
                        if (option.type == undefined && option.text) {
                            value = option.text;
                        }
                        else if (option.type && option.value) {
                            if (option.value instanceof Object) {
                                value = JSON.stringify(option.value);
                            }
                            else {
                                value = option.value;
                            }
                        }
                        if (value) {
                            inputSuggestions = inputSuggestions.concat(value);
                        }
                    });
                }
                // Carousel
                if (message.type == 'application/vnd.lime.collection+json' &&
                    message.content &&
                    message.content.items) {
                    message.content.items.forEach((i) => {
                        if (i.options) {
                            i.options.forEach((o) => {
                                let value;
                                if (o.value) {
                                    if (o.value.type == 'text/plain') {
                                        value = o.value.value;
                                    }
                                    else {
                                        value = JSON.stringify(o.value);
                                    }
                                }
                                else if (o.label &&
                                    o.label.type == 'text/plain') {
                                    value = o.label.value;
                                }
                                if (value) {
                                    inputSuggestions = inputSuggestions.concat(value);
                                }
                            });
                        }
                    });
                }
            }
        });
        // Remove duplicate values
        this.state.$inputSuggestions = Array.from(new Set(inputSuggestions).values());
    }
    openHttpContentSidebarDetail(action, actionIndex) {
        return this.openSidebarDetail(HttpContentController, HttpContentView, {
            action: angular.copy(action.action),
            application: this.application,
            $translate: this.$translate,
            $onStateChanged: async (changedAction) => {
                await this.onActionSave(changedAction.settings, actionIndex);
            },
            ModalService: this.ModalService,
            state: this.state,
        });
    }
    openContentSurveySidebarDetail(action, actionIndex) {
        return this.openSidebarDetail(SurveyContentController, SurveyContentView, {
            action: angular.copy(action.action),
            application: this.application,
            $translate: this.$translate,
            $onStateChanged: async (changedAction) => {
                await this.onActionSave(changedAction.settings, actionIndex);
            },
            ModalService: this.ModalService,
            state: this.state,
        });
    }
    openRawContentSidebarDetail(action, actionIndex) {
        return this.openSidebarDetail(RawContentController, RawContentView, {
            action: angular.copy(action.action),
            application: this.application,
            $translate: this.$translate,
            $onStateChanged: async (changedAction) => {
                await this.onActionSave(changedAction.settings, actionIndex);
            },
            ModalService: this.ModalService,
            state: this.state,
        });
    }
    async openInputSidebarDetail(action, $event) {
        //Workaround to avoid eval ng-click when user clicks on bin
        if ($event &&
            ($event.target.nodeName === 'IMG' ||
                $event.target.classList.value.includes('trashIco'))) {
            return;
        }
        await this.openSidebarDetail(InputController, InputView, {
            action,
            application: this.application,
            state: this.state,
            $timeout: this.$timeout,
            $translate: this.$translate,
            $onStateChanged: () => {
                this.onUpdateAndSave();
            },
            ModalService: this.ModalService,
        });
    }
    async openSidebarDetail(controller, template, inputs) {
        this.showCounter = false;
        try {
            const sidenav = await this.SidebarContentService.showSidebar({
                controller: controller,
                controllerAs: '$ctrl',
                appendToElement: this.$document[0].getElementById('sidebar-detail-content'),
                template: template,
                allowMultiple: true,
                inputs: inputs,
            });
            this.BuilderTabsService.addSidebar(sidenav);
            await sidenav.closeDeferred.promise;
            this.showCounter = this.shouldShowContentCounter();
        }
        catch (e) {
            console.error(e);
        }
    }
    deleteContentAction(index) {
        const action = this.state.$contentActions[index];
        this.state.$contentActions = immutableSplice(this.state.$contentActions, index, 1);
        // Remove all chatstates between the deleted action and the previous content.
        while (--index >= 0) {
            const previousAction = this.state.$contentActions[index];
            if (previousAction &&
                previousAction.action &&
                previousAction.action.type == ActionType.SendMessage &&
                previousAction.action.settings.type ==
                    'application/vnd.lime.chatstate+json') {
                this.state.$contentActions = immutableSplice(this.state.$contentActions, index, 1);
            }
            else {
                break;
            }
        }
        if (action && action.action.settings && action.action.settings.type == 'application/vnd.lime.select+json') {
            this.state.$conditionOutputs = this.state.$conditionOutputs.filter(out => out.$contentId !== action.action.$id);
        }
        this.checkContentLength();
        this.trackBlockContentDeleted(action.action.$typeOfContent);
        this.onUpdateAndSave();
    }
    trackAndSaveOutputSort() {
        this.trackBlockContentPositionChanged();
        this.onUpdateAndSave();
    }
    createCardContent(document = {}, position = 'left', editable = true, deletable = true) {
        const cardContent = new CardContent({
            document,
            editable,
            deletable,
            position,
        });
        this.bindCardListeners(cardContent);
        return cardContent;
    }
    createOutputConditions(outputConditions, contentAction) {
        const options = contentAction.action.$cardContent.document.content.options.map(option => option.text);
        let outputs = [];
        options.forEach(element => {
            outputs = outputs.concat(OutputViewModel.createFromContentOption(contentAction.action.$id, element));
        });
        return outputConditions.concat(outputs);
    }
    // Segment
    trackBlockContentAdded(contentType) {
        this.BuilderSegmentService.trackBlockContentAdded({
            ContentType: contentType,
            BlockID: this.state.id,
        }, true);
    }
    trackClickUrlContent(property) {
        this.BuilderSegmentService.trackClickDocumentUrl({
            LinkName: property,
        }, true);
    }
    trackBlockContentChanged(ContentType) {
        this.BuilderSegmentService.trackBlockContentChanged({
            ContentType,
            BlockID: this.state.id,
        }, true);
    }
    trackBlockContentDeleted(contentType) {
        this.BuilderSegmentService.trackBlockContentDeleted({
            ContentType: contentType,
            BlockID: this.state.id,
        }, true);
    }
    trackBlockContentPositionChanged() {
        this.BuilderSegmentService.trackBlockContentPositionChanged({
            BlockID: this.state.id,
        }, true);
    }
    trackBlockContentWaitInputEnabled() {
        this.BuilderSegmentService.trackBlockContentWaitInputEnabled({
            BlockID: this.state.id,
        }, true);
    }
    trackBlockContentWaitInputDisabled() {
        this.BuilderSegmentService.trackBlockContentWaitInputDisabled({
            BlockID: this.state.id,
        }, true);
    }
    trackBuilderBlockAiActivated(aiType) {
        this.BuilderSegmentService.trackBuilderBlockAiActivated({
            BlockID: this.state.id,
            AiType: aiType,
        }, true);
    }
    checkLimitMenu(actionIndex) {
        let maxCharacters = false;
        const maxTextSize = 24;
        const maxOptions = 10;
        if (!this.state?.$contentActions[actionIndex]?.action?.settings?.content?.options) {
            return;
        }
        this.state.$contentActions[actionIndex].action.settings.content.options.forEach((o) => {
            if (o.type == undefined && o.text && o.text.length > maxTextSize) {
                maxCharacters = true;
            }
        });
        this.state.$contentActions[actionIndex].action.settings.content.limitMenu = maxCharacters || (this.state.$contentActions[actionIndex].action.settings.content.options.length > maxOptions && this.state?.$contentActions[actionIndex]?.action?.settings?.content?.scope != 'immediate');
    }
    checkLimitQuikReply(actionIndex) {
        let maxCharacters = false;
        const maxTextSize = 20;
        const maxOptions = 3;
        if (!this.state?.$contentActions[actionIndex]?.action?.settings?.content?.options) {
            return;
        }
        this.state.$contentActions[actionIndex].action.settings.content.options.forEach((o) => {
            if (o.type == undefined && o.text && o.text.length > maxTextSize) {
                maxCharacters = true;
            }
            this.state.$contentActions[actionIndex].action.settings.content.quikReply = maxCharacters || (this.state.$contentActions[actionIndex].action.settings.content.options.length > maxOptions && this.state?.$contentActions[actionIndex]?.action?.settings?.content?.scope == 'immediate');
        });
    }
};
ContentsComponent.$inject = ['BuilderContentService', 'BuilderTabsService', 'SidebarContentService', 'BuilderSegmentService', '$document', '$timeout', '$translate', 'ModalService', 'UndoRedoService', '$scope', 'BuilderStateService', 'ActionContentService'];
ContentsComponent = __decorate([
    Component({
        template,
        bindings: {
            state: '=',
            onAction: '&?',
            application: '<',
        },
    }),
    __metadata("design:paramtypes", [typeof (_a = typeof BuilderContentService !== "undefined" && BuilderContentService) === "function" ? _a : Object, typeof (_b = typeof BuilderTabsService !== "undefined" && BuilderTabsService) === "function" ? _b : Object, typeof (_c = typeof SidebarContentService !== "undefined" && SidebarContentService) === "function" ? _c : Object, typeof (_d = typeof BuilderSegmentService !== "undefined" && BuilderSegmentService) === "function" ? _d : Object, Object, typeof (_e = typeof ITimeoutService !== "undefined" && ITimeoutService) === "function" ? _e : Object, typeof (_f = typeof translate !== "undefined" && translate.ITranslateService) === "function" ? _f : Object, Object, typeof (_g = typeof UndoRedoService !== "undefined" && UndoRedoService) === "function" ? _g : Object, typeof (_h = typeof angular !== "undefined" && angular.IScope) === "function" ? _h : Object, typeof (_j = typeof BuilderStateService !== "undefined" && BuilderStateService) === "function" ? _j : Object, typeof (_k = typeof ActionContentService !== "undefined" && ActionContentService) === "function" ? _k : Object])
], ContentsComponent);
export { ContentsComponent };
